import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCompassPointer: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"compass-pointer, arrow, route"} maskId="square-filled-radius-0-stroke-1-IconCompassPointer"><path d="M20.9854 20.9033L12 17.5332L3.01465 20.9033L12 2.08984L20.9854 20.9033Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCompassPointer;
